/*
 * @File index.js
 * @Description This File is for foodies store module
 */
import state from '@/store/modules/foodies/state'
import mutations from '@/store/modules/foodies/mutations'
import actions from '@/store/modules/foodies/actions'
import getters from '@/store/modules/foodies/getters'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
